import React, { useEffect, useState } from 'react';
import { database, auth, functions } from '../modules/fireBase';
import {
  Table,
  Input,
  Popconfirm,
  Form,
  Button,
  Typography,
  Row,
  Col,
  Progress,
  Tooltip,
  message,
} from 'antd';
import '../assets/styles/MessageManuel.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {
  BackwardOutlined,
  ForwardOutlined,
  MailOutlined,
  SendOutlined,
  LoadingOutlined,
  CheckOutlined,
  WarningOutlined,
  WifiOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import CustomLayout from './CustomLayout';

const { Title, Text } = Typography;
const { TextArea } = Input;

export default function MessageManuel() {
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      width: '45%',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.nom.localeCompare(b.nom),
      //shouldCellUpdate: () => false,
    },
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      width: '45%',
      sorter: (a, b) => a.prenom.localeCompare(b.prenom),
      //shouldCellUpdate: () => false,
    },
  ];
  const statusColumn = [
    {
      dataIndex: 'status',
      width: '10%',
      render: (status) =>
        status ? (
          status?.type === 'error' ? (
            <Tooltip title={status.message} placement="left">
              {StatusIcon(status.type)}
              {/* <StatusIcon status={status.type} /> */}
            </Tooltip>
          ) : (
            StatusIcon(status)
          )
        ) : null,
    },
  ];
  const [carnetAdresse, setCarnetAdresse] = useState([]);
  const [destinataires, setDestinataires] = useState([]);
  const [messageCaracteres, setMessageCaracteres] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [messageToSend, setMessageToSend] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [sendingDone, setSendingDone] = useState(false);
  const [settings, setSettings] = useState([]);
  const StatusIcon = (status) => {
    return status === 'loading' ? (
      <WifiOutlined style={{ color: 'orange' }} />
    ) : //'loading'
    status === 'accepted' ? (
      <CheckOutlined style={{ color: 'green' }} />
    ) : //'sent'
    status === 'error' ? (
      <WarningOutlined style={{ color: 'red' }} />
    ) : (
      //'error'
      ''
    );
  };

  const addAll = () => {
    setDestinataires((prevDestinataires) => [
      ...prevDestinataires,
      ...carnetAdresse,
    ]);
    setCarnetAdresse([]);
  };

  const removeAll = () => {
    setCarnetAdresse((prevCarnetAdresse) => [
      ...destinataires,
      ...prevCarnetAdresse,
    ]);
    setDestinataires([]);
  };
  const sendmessage = () => {
    setDisabled(true);
    var sendMessage = functions.httpsCallable('sendmessage');
    let newDestinataires = [...destinataires];
    destinataires.forEach((destinataire) => {
      //console.log(destinataire);
      let newDestinataireIndex = newDestinataires.findIndex(
        (item) => destinataire.key === item.key
      );
      let newDestinataire = { ...destinataire, status: 'loading' };
      newDestinataires.splice(newDestinataireIndex, 1, newDestinataire);
      setDestinataires(newDestinataires);
      sendMessage({
        destinataire: destinataire,
        message: messageToSend,
      }).then((result) => {
        updateStatus(result.data.destinataire, result.data.message.status);
        console.log(result.data);
      });
    });
  };
  const updateStatus = (destinataire, status) => {
    //let newDestinataires = [...destinataires];
    //let newDestinataire = { ...destinataire, status: status };
    //newDestinataires.splice(index, 1, newDestinataire);
    //setDestinataires(newDestinataires);
    setDestinataires((prevDestinataires) => {
      //console.log(prevDestinataires);
      let index = destinataires.findIndex(
        (item) => destinataire.key === item.key
      );
      let newDestinataires = [...prevDestinataires];
      let newDestinataire = { ...destinataire, status: status };
      newDestinataires.splice(index, 1, newDestinataire);
      return newDestinataires;
    });
    setPercentage((prevPercentage) => {
      let newPercentage = prevPercentage + 100 / destinataires.length;
      return newPercentage;
    });
  };
  useEffect(() => {
    database.ref('chantierContacts').on('value', (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setCarnetAdresse(firebaseData);
      }
    });
    database.ref('reglages').once('value', (snapshot) => {
      if (snapshot.val()) {
        setSettings(snapshot.val());
        console.log(snapshot.val());
      }
    });
  }, []);
  useEffect(() => {
    if (Math.round(percentage) === 100) {
      message.success({
        content: 'Le traitement des messages est terminé!',
      });
      setSendingDone(true);
      if (settings.sendconfirmation) {
        var sendMessage = functions.httpsCallable('sendmessage');
        sendMessage({
          destinataire: { phonenumber: settings.confirmationnumber },
          message: `${destinataires.length} message${
            destinataires.length > 1 ? 's ont' : ' a'
          } été envoyé${destinataires.length > 1 ? 's' : ''} manuellement`,
        });
      }
    }
  }, [percentage]);
  return (
    <CustomLayout
      selectedKey="4"
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 40px)',
      }}>
      <Title>Message Manuel</Title>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingLeft: 50,
          paddingRight: 50,
          paddingTop: 10,
          paddingBottom: 10,
        }}>
        <TextArea
          rows={4}
          autoSize={true}
          style={{ minHeight: 100 }}
          disabled={disabled}
          placeholder="Écrivez votre message ici"
          onChange={(e) => {
            setMessageCaracteres(e.target.value.length);
            setMessageToSend(e.target.value);
          }}
        />
        <span style={{ textAlign: 'right' }}>
          Nombre de caractères : {messageCaracteres}/1600
        </span>
      </div>
      <Row
        style={{
          flex: 1,
          minHeight: '0px',
          paddingBottom: 20,
        }}>
        <Col
          span={10}
          style={{
            display: 'flex',
            flexDirection: 'column',
            //minHeight: '0px',
            height: '100%',
          }}>
          <Title level={4}>Carnet d'adresse</Title>
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
            }}>
            <Table
              className="messagemanueltable"
              dataSource={carnetAdresse}
              columns={columns}
              pagination={false}
              rowClassName={disabled && 'disabled-row'}
              bordered
              sticky
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {}, // click row
                  onClick: (event) => {
                    let newDestinataires = [...destinataires];
                    newDestinataires.push(record);
                    setDestinataires(newDestinataires);
                    let newCarnetAdresse = carnetAdresse.filter(
                      (element) => element !== record
                    );
                    setCarnetAdresse(newCarnetAdresse);
                  }, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </Col>
        <Col
          span={4}
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
          }}>
          <Button
            style={{ height: 90, width: 90, marginBottom: 20 }}
            disabled={disabled}
            onClick={() => addAll()}>
            <ForwardOutlined style={{ fontSize: 50 }} />
          </Button>
          <Button
            style={{ height: 90, width: 90 }}
            disabled={disabled}
            onClick={() => removeAll()}>
            <BackwardOutlined style={{ fontSize: 50 }} />
          </Button>
        </Col>
        <Col
          span={10}
          style={{
            display: 'flex',
            flexDirection: 'column',
            //minHeight: '0px',
            height: '100%',
          }}>
          <Title level={4}>Destinataires ({destinataires.length})</Title>
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
            }}>
            <Table
              className="messagemanueltable"
              dataSource={destinataires}
              columns={[...columns, ...statusColumn]}
              pagination={false}
              bordered
              sticky
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {}, // click row
                  onClick: (event) => {
                    if (disabled) {
                      return;
                    }
                    let newCarnetAdresse = [...carnetAdresse];
                    newCarnetAdresse.push(record);
                    setCarnetAdresse(newCarnetAdresse);
                    let newDestinataires = destinataires.filter(
                      (element) => element !== record
                    );
                    setDestinataires(newDestinataires);
                  }, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </Col>
      </Row>
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <Progress
          type="line"
          percent={Math.round(percentage)}
          strokeColor="#1DA57A"
          format={(percent) =>
            percent === 100
              ? 'Terminé!'
              : `${Math.round((percent * destinataires.length) / 100)}/${
                  destinataires.length
                }`
          }
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 20,
          }}>
          <Button
            type="primary"
            disabled={disabled}
            style={{ width: 300, height: 50, marginRight: 20 }}
            onClick={() => {
              if (messageToSend.length === 0) {
                message.error('Veuillez rédiger un message');
                return;
              }
              if (destinataires.length === 0) {
                message.error(
                  'La liste de destinataires est vide. Veuillez indiquer au minimum un destinataire.'
                );
                return;
              }
              confirmAlert({
                title: "Confirmer l'envoi",
                message: `Êtes-vous certain de vouloir envoyer ${
                  destinataires.length === 1
                    ? 'le message'
                    : `les ${destinataires.length} messages`
                } ?`,
                buttons: [
                  {
                    label: 'Oui',
                    onClick: () => sendmessage(),
                  },
                  {
                    label: 'Non',
                    //onClick: () => alert('Click No'),
                  },
                ],
              });
            }}>
            {sendingDone ? (
              <CheckOutlined style={{ fontSize: 30 }} />
            ) : disabled ? (
              <LoadingOutlined style={{ color: '#1DA57A', fontSize: 20 }} />
            ) : (
              <MailOutlined style={{ fontSize: 30 }} />
            )}
          </Button>
          {sendingDone && (
            <Button
              type="primary"
              danger
              style={{ width: 300, height: 50 }}
              onClick={() => window.location.reload()}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <ReloadOutlined style={{ fontSize: 30, marginRight: 15 }} />
                <Text style={{ color: 'white' }}>Nouveau message</Text>
              </div>
            </Button>
          )}
        </div>
      </div>
    </CustomLayout>
  );
}
